export default __webpack_public_path__ + "static/media/homeImage.38095b95.jpg";